var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2.005A2.005 2.005 0 0 1 2.005 0h19.988A2.004 2.004 0 0 1 24 2.005v19.988A2.005 2.005 0 0 1 21.994 24H2.005A2.006 2.006 0 0 1 0 21.994V2.005Zm9.5 7.146h3.25v1.632C13.218 9.844 14.417 9 16.221 9c3.457 0 4.276 1.869 4.276 5.297v6.352H17v-5.57c0-1.953-.47-3.055-1.66-3.055-1.653 0-2.34 1.188-2.34 3.055v5.57H9.5V9.15Zm-6 11.348H7V9H3.5V20.499Zm4-15.25a2.25 2.25 0 1 1-4.5.1 2.25 2.25 0 0 1 4.5-.1Z","fill":"#DEDEDE"}));
}

Linkedin.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
